/**
 * Homepage delivery-slots reconciler.
 * The section server-renders an accurate baseline (no CLS, no JS dependency for
 * first paint). After the page is idle this fetches the live delivery config and
 * rewrites a table ONLY if the stored schedule has drifted from the baseline, so
 * the tables self-heal without a redeploy while staying CWV-neutral in the common
 * (unchanged) case.
 */
(function () {
  var root = document.querySelector('[data-wf-delivery-slots]');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint');
  if (!endpoint) return;

  var DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function ampm(h, m) { var hr = (h % 12) || 12; return hr + ':' + pad2(m) + ' ' + (h < 12 ? 'AM' : 'PM'); }
  function hourLabel(h) { var hr = (h % 12) || 12; return hr + ' ' + (h < 12 ? 'AM' : 'PM'); }
  function winPart(h, m) { var hr = (h % 12) || 12; return hr + ':' + pad2(m); }

  function fmtDays(days) {
    var d = days.slice().sort(function (a, b) { return a - b; });
    var map = { '1,2,3,4,5,6': 'Mon–Sat', '1,2,3,4,5': 'Mon–Fri', '0': 'Sundays', '6': 'Saturdays', '0,1,2,3,4,5,6': 'Daily' };
    var k = d.join(',');
    if (map[k]) return map[k];
    var contig = d.every(function (v, i) { return i === 0 || v === d[i - 1] + 1; });
    if (contig && d.length > 1) return DAYS_SHORT[d[0]] + '–' + DAYS_SHORT[d[d.length - 1]];
    return d.map(function (x) { return DAYS_SHORT[x]; }).join(', ');
  }
  function sundayOnly(days) { return days.length === 1 && days[0] === 0; }

  function buildStandard(slots) {
    return slots.slice().sort(function (a, b) {
      var sa = sundayOnly(a.availableDays) ? 1 : 0, sb = sundayOnly(b.availableDays) ? 1 : 0;
      return sa !== sb ? sa - sb : a.startHour - b.startHour;
    }).map(function (t) {
      return [hourLabel(t.startHour) + ' – ' + hourLabel(t.endHour), fmtDays(t.availableDays), ampm(t.cutoffHour, t.cutoffMinute)];
    });
  }

  function buildExpress(slots) {
    var groups = {}, order = [];
    slots.forEach(function (t) {
      var key = t.startHour + ':' + (t.startMinute || 0) + '-' + t.endHour + ':' + (t.endMinute || 0);
      if (!groups[key]) { groups[key] = { sh: t.startHour, sm: t.startMinute || 0, eh: t.endHour, em: t.endMinute || 0, slots: [] }; order.push(key); }
      groups[key].slots.push(t);
    });
    order.sort(function (a, b) { return groups[a].sh - groups[b].sh || groups[a].sm - groups[b].sm; });
    function cutForDay(g, day) {
      var hit = g.slots.filter(function (t) { return t.availableDays.indexOf(day) >= 0; });
      return hit.length ? ampm(hit[0].cutoffHour, hit[0].cutoffMinute) : 'N/A';
    }
    return order.map(function (k) {
      var g = groups[k];
      return [winPart(g.sh, g.sm) + ' – ' + winPart(g.eh, g.em), cutForDay(g, 1), cutForDay(g, 6), cutForDay(g, 0)];
    });
  }

  function domRows(tbody) {
    return Array.prototype.map.call(tbody.rows, function (r) {
      return Array.prototype.map.call(r.cells, function (c) { return c.textContent.trim(); });
    });
  }
  function renderRows(tbody, rows, labels) {
    tbody.innerHTML = rows.map(function (r) {
      return '<tr>' + r.map(function (cell, i) { return '<td data-label="' + labels[i] + '">' + cell + '</td>'; }).join('') + '</tr>';
    }).join('');
  }

  function reconcile() {
    fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        var s = d.settings || d || {};
        var std = root.querySelector('[data-wf-slots-standard] tbody');
        var exp = root.querySelector('[data-wf-slots-express] tbody');
        if (Array.isArray(s.timeslots) && s.timeslots.length && std) {
          var sr = buildStandard(s.timeslots);
          if (JSON.stringify(sr) !== JSON.stringify(domRows(std))) renderRows(std, sr, ['Delivery Slot', 'Days', 'Order By']);
        }
        if (Array.isArray(s.express_timeslots) && s.express_timeslots.length && exp) {
          var er = buildExpress(s.express_timeslots);
          if (JSON.stringify(er) !== JSON.stringify(domRows(exp))) renderRows(exp, er, ['Express Window', 'Mon–Fri', 'Saturday', 'Sunday']);
        }
      })
      .catch(function () { /* keep server-rendered baseline */ });
  }

  if ('requestIdleCallback' in window) window.requestIdleCallback(reconcile, { timeout: 3000 });
  else setTimeout(reconcile, 1200);
})();
